/**
 * @description This is a list of nouns that use the same form for both singular and plural.
 *              This list should remain entirely in lower case to correctly match Strings.
 * @private
 */
export const uncountable_words = [
	// 'access',
	'accommodation',
	'adulthood',
	'advertising',
	'advice',
	'aggression',
	'aid',
	'air',
	'aircraft',
	'alcohol',
	'anger',
	'applause',
	'arithmetic',
	// 'art',
	'assistance',
	'athletics',
	// 'attention',

	'bacon',
	'baggage',
	// 'ballet',
	// 'beauty',
	'beef',
	// 'beer',
	// 'behavior',
	'biology',
	// 'billiards',
	'blood',
	'botany',
	// 'bowels',
	'bread',
	// 'business',
	'butter',

	'carbon',
	'cardboard',
	'cash',
	'chalk',
	'chaos',
	'chess',
	'crossroads',
	'countryside',

	// 'damage',
	'dancing',
	// 'danger',
	'deer',
	// 'delight',
	// 'dessert',
	'dignity',
	'dirt',
	// 'distribution',
	'dust',

	'economics',
	'education',
	'electricity',
	// 'employment',
	// 'energy',
	'engineering',
	'enjoyment',
	// 'entertainment',
	'envy',
	'equipment',
	'ethics',
	'evidence',
	'evolution',

	// 'failure',
	// 'faith',
	'fame',
	'fiction',
	// 'fish',
	'flour',
	'flu',
	'food',
	// 'freedom',
	// 'fruit',
	'fuel',
	'fun',
	// 'funeral',
	'furniture',

	'gallows',
	'garbage',
	'garlic',
	// 'gas',
	'genetics',
	// 'glass',
	'gold',
	'golf',
	'gossip',
	'grammar',
	// 'grass',
	'gratitude',
	'grief',
	// 'ground',
	'guilt',
	'gymnastics',

	// 'hair',
	'happiness',
	'hardware',
	'harm',
	'hate',
	'hatred',
	'health',
	'heat',
	// 'height',
	'help',
	'homework',
	'honesty',
	'honey',
	'hospitality',
	'housework',
	'humour',
	'hunger',
	'hydrogen',

	'ice',
	'importance',
	'inflation',
	'information',
	// 'injustice',
	'innocence',
	// 'intelligence',
	'iron',
	'irony',

	'jam',
	// 'jealousy',
	// 'jelly',
	'jewelry',
	// 'joy',
	'judo',
	// 'juice',
	// 'justice',

	'karate',
	// 'kindness',
	'knowledge',

	// 'labour',
	'lack',
	// 'land',
	'laughter',
	'lava',
	'leather',
	'leisure',
	'lightning',
	'linguine',
	'linguini',
	'linguistics',
	'literature',
	'litter',
	'livestock',
	'logic',
	'loneliness',
	// 'love',
	'luck',
	'luggage',

	'macaroni',
	'machinery',
	'magic',
	// 'mail',
	'management',
	'mankind',
	'marble',
	'mathematics',
	'mayonnaise',
	'measles',
	// 'meat',
	// 'metal',
	'methane',
	'milk',
	'minus',
	'money',
	// 'moose',
	'mud',
	'music',
	'mumps',

	'nature',
	'news',
	'nitrogen',
	'nonsense',
	'nurture',
	'nutrition',

	'obedience',
	'obesity',
	// 'oil',
	'oxygen',

	// 'paper',
	// 'passion',
	'pasta',
	'patience',
	// 'permission',
	'physics',
	'poetry',
	'pollution',
	'poverty',
	// 'power',
	'pride',
	// 'production',
	// 'progress',
	// 'pronunciation',
	'psychology',
	'publicity',
	'punctuation',

	// 'quality',
	// 'quantity',
	'quartz',

	'racism',
	// 'rain',
	// 'recreation',
	'relaxation',
	'reliability',
	'research',
	'respect',
	'revenge',
	'rice',
	'rubbish',
	'rum',

	'safety',
	// 'salad',
	// 'salt',
	// 'sand',
	// 'satire',
	'scenery',
	'seafood',
	'seaside',
	'series',
	'shame',
	'sheep',
	'shopping',
	// 'silence',
	'sleep',
	// 'slang'
	'smoke',
	'smoking',
	'snow',
	'soap',
	'software',
	'soil',
	// 'sorrow',
	// 'soup',
	'spaghetti',
	// 'speed',
	'species',
	// 'spelling',
	// 'sport',
	'steam',
	// 'strength',
	'stuff',
	'stupidity',
	// 'success',
	// 'sugar',
	'sunshine',
	'symmetry',

	// 'tea',
	'tennis',
	'thirst',
	'thunder',
	'timber',
	// 'time',
	// 'toast',
	// 'tolerance',
	// 'trade',
	'traffic',
	'transportation',
	// 'travel',
	'trust',

	// 'understanding',
	'underwear',
	'unemployment',
	'unity',
	// 'usage',

	'validity',
	'veal',
	'vegetation',
	'vegetarianism',
	'vengeance',
	'violence',
	// 'vision',
	'vitality',

	'warmth',
	// 'water',
	'wealth',
	'weather',
	// 'weight',
	'welfare',
	'wheat',
	// 'whiskey',
	// 'width',
	'wildlife',
	// 'wine',
	'wisdom',
	// 'wood',
	// 'wool',
	// 'work',

	// 'yeast',
	'yoga',

	'zinc',
	'zoology',
];

export default uncountable_words
